import React, { useState } from "react"
import { Link } from "react-router-dom"
import lobbyBg from "@/images/backgrounds/lobby-background.webp"
import LandingPageNavbar from "@/Components/LandingPageNavbar"

// Import gallery images
// import gallery0 from "@/images/gallery/gallery0.png"
// import gallery1 from "@/images/gallery/gallery1.png"
// import gallery2 from "@/images/gallery/gallery2.png"
// import gallery3 from "@/images/gallery/gallery3.png"
// import gallery4 from "@/images/gallery/gallery4.png"
// import gallery5 from "@/images/gallery/gallery5.png"
// import gallery6 from "@/images/gallery/gallery6.png"

// const galleryImages = [
//   { src: gallery0, alt: "Dealmaster Gameplay Screenshot 1" },
//   { src: gallery1, alt: "Dealmaster Gameplay Screenshot 2" },
//   { src: gallery2, alt: "Dealmaster Gameplay Screenshot 3" },
//   { src: gallery3, alt: "Dealmaster Gameplay Screenshot 4" },
//   { src: gallery4, alt: "Dealmaster Gameplay Screenshot 5" },
//   { src: gallery5, alt: "Dealmaster Gameplay Screenshot 6" },
//   { src: gallery6, alt: "Dealmaster Gameplay Screenshot 7" },
// ]

const Gallery: React.FC = () => {
  // const [selectedImage, setSelectedImage] = useState<number | null>(null)

  // const openModal = (index: number) => {
  //   setSelectedImage(index)
  // }

  // const closeModal = () => {
  //   setSelectedImage(null)
  // }

  // const nextImage = () => {
  //   if (selectedImage !== null) {
  //     setSelectedImage((selectedImage + 1) % galleryImages.length)
  //   }
  // }

  // const prevImage = () => {
  //   if (selectedImage !== null) {
  //     setSelectedImage(
  //       selectedImage === 0 ? galleryImages.length - 1 : selectedImage - 1
  //     )
  //   }
  // }
  return <div>Gallery</div>
  // return (
  //   <div
  //     className="min-h-screen flex flex-col relative overflow-hidden"
  //     style={{
  //       backgroundImage: `url(${lobbyBg})`,
  //       backgroundSize: "cover",
  //       backgroundPosition: "center",
  //     }}
  //   >
  //     {/* Warm vignette overlay for blending */}
  //     <div className="absolute inset-0 bg-gradient-to-br from-[#f5e2c3cc] via-[#e49e78bb] to-[#4a2e19ee] z-0" />

  //     {/* Content */}
  //     <div className="relative z-10 flex flex-col min-h-screen">
  //       {/* Navbar */}
  //       <LandingPageNavbar showHomeLink={true} />

  //       {/* Main Content */}
  //       <div className="flex-1 pt-24 pb-8 px-6">
  //         <div className="max-w-7xl mx-auto mt-10">
  //           {/* Header */}
  //           <div className="text-center mb-12">
  //             <h1 className="text-5xl md:text-6xl font-extrabold text-[#a13a2b] mb-4 drop-shadow-lg font-fourth tracking-wider vintage-text-shadow">
  //               Game <span className="text-[#4a2e19]">Gallery</span>
  //             </h1>
  //             <p className="text-xl text-[#4a2e19] max-w-2xl mx-auto leading-relaxed drop-shadow font-fourth vintage-text-shadow">
  //               Explore the stunning visuals and exciting gameplay moments from
  //               Dealmaster
  //             </p>
  //           </div>

  //           {/* Gallery Grid */}
  //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
  //             {galleryImages.map((image, index) => (
  //               <div
  //                 key={index}
  //                 className="group relative overflow-hidden rounded-2xl shadow-2xl vintage-card cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-3xl"
  //                 onClick={() => openModal(index)}
  //               >
  //                 <img
  //                   src={image.src}
  //                   alt={image.alt}
  //                   className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
  //                 />
  //                 <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
  //                 <div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
  //                   <p className="text-sm font-semibold">Click to view</p>
  //                 </div>
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       </div>

  //       {/* Image Modal */}
  //       {selectedImage !== null && (
  //         <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
  //           <div className="relative max-w-4xl max-h-full">
  //             <img
  //               src={galleryImages[selectedImage].src}
  //               alt={galleryImages[selectedImage].alt}
  //               className="max-w-full max-h-full object-contain rounded-lg"
  //             />

  //             {/* Close button */}
  //             <button
  //               onClick={closeModal}
  //               className="absolute top-4 right-4 bg-[#a13a2b] hover:bg-[#4a2e19] text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg transition-all duration-200"
  //             >
  //               <i className="fas fa-times text-xl"></i>
  //             </button>

  //             {/* Navigation buttons */}
  //             <button
  //               onClick={prevImage}
  //               className="absolute left-4 top-1/2 -translate-y-1/2 bg-[#a13a2b] hover:bg-[#4a2e19] text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg transition-all duration-200"
  //             >
  //               <i className="fas fa-chevron-left text-xl"></i>
  //             </button>
  //             <button
  //               onClick={nextImage}
  //               className="absolute right-4 top-1/2 -translate-y-1/2 bg-[#a13a2b] hover:bg-[#4a2e19] text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg transition-all duration-200"
  //             >
  //               <i className="fas fa-chevron-right text-xl"></i>
  //             </button>

  //             {/* Image counter */}
  //             <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-4 py-2 rounded-full text-sm">
  //               {selectedImage + 1} / {galleryImages.length}
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //     </div>

  //     {/* Vintage style utility classes */}
  //     <style>{`
  //       .vintage-border { box-shadow: 0 4px 0 #A13A2B, 0 8px 24px #2A1209; }
  //       .vintage-text-shadow { text-shadow: 1px 2px 0 #2A1209, 0 2px 8px #4A2E19; }
  //       .vintage-link { letter-spacing: 0.5px; }
  //       .vintage-card { 
  //         background: rgba(245, 226, 195, 0.1);
  //         backdrop-filter: blur(10px);
  //         border: 2px solid rgba(161, 58, 43, 0.3);
  //       }
  //       .shadow-3xl { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5); }
  //     `}</style>
  //   </div>
  // )
}

export default Gallery
